'use client';

import {
  useState
} from 'react';

import {
  BRAND_GRADIENT,
  BRAND_GRADIENT_DARK_GLASS,
  PRIMARY_BUTTON_CLASSES
} from '@repo/brand';

export default function VerifyForm() {

  const [ value, setValue ] = useState('');
  const [ status, setStatus ] = useState<'idle' | 'loading' | 'valid' | 'invalid'>('idle');

  const handleVerify = () => {

    if (!value.trim()) {

      return;
    }

    setStatus('loading');
    // Placeholder - wire to real verification API when ready
    setTimeout(() => {

      setStatus(value.length > 5 ? 'valid' : 'invalid');
    }, 800);
  };

  return (
    <div className="flex flex-col items-center gap-4 w-full max-w-md mx-auto">
      <div className="flex flex-col sm:flex-row gap-3 w-full">
        <input
          type="text"
          value={value}
          onChange={(e) => {

            setValue(e.target.value);
            setStatus('idle');
          }}
          onKeyDown={(e) => e.key === 'Enter' && handleVerify()}
          placeholder="Enter certificate number"
          className="flex-1 px-4 py-3 rounded-full border border-gray-200 dark:bg-gray-800 dark:border-gray-700 dark:text-white text-sm focus:outline-none focus:border-[rgba(1,158,250,0.5)] transition-colors"
        />
        <button
          onClick={handleVerify}
          disabled={status === 'loading'}
          className={`px-6 py-3 disabled:opacity-60 disabled:hover:scale-100 ${ PRIMARY_BUTTON_CLASSES } ${ BRAND_GRADIENT_DARK_GLASS }`}
          style={{
            background: BRAND_GRADIENT
          }}
        >
          {status === 'loading' ? 'Checking…' : 'Verify'}
        </button>
      </div>

      {status === 'valid' && (
        <div className="flex items-center gap-2 text-sm font-medium text-green-600">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="w-4 h-4 fill-green-600">
            <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
          </svg>
          Certificate is valid.
        </div>
      )}
      {status === 'invalid' && (
        <div className="flex items-center gap-2 text-sm font-medium text-red-500">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="w-4 h-4 fill-red-500">
            <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" />
          </svg>
          Certificate not found. Please check the number and try again.
        </div>
      )}
    </div>
  );
}
